import { slice } from './slice'

const routerActions = slice.actions

export default routerActions
